import { useEffect, useState } from "react";

import PropTypes from "prop-types";

import {
  CUSTOMER_MULTI_SELECT_ACTIONS,
  SUPPLIER_MULTI_SELECT_ACTIONS,
} from "@/features/chart-of-account-preferences";
import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";
import { OutletRoleEnum } from "../outlet-role";
import { OutletFormDialog } from "../outlet-form-dialog";

import { Button } from "@mui/material";

export const EditOutletFormDialog = ({ onClose, outletId, onSubmitted }) => {
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchOutlet = async () => {
      setIsLoading(true);
      try {
        const {
          data: {
            data: {
              name,
              address,
              whatsapp,
              role,
              status,
              company,
              accountingActionChartOfAccounts,
              sellerBankAccounts,
            },
          },
        } = await apiClient.get(`outlets/${outletId}`, {
          params: {
            withAccountingActionChartOfAccounts: true,
            withSellerBankAccounts: true,
            withCompany: true,
          },
        });

        const multiSelectActions =
          role === OutletRoleEnum.HUB
            ? SUPPLIER_MULTI_SELECT_ACTIONS
            : CUSTOMER_MULTI_SELECT_ACTIONS;

        setDefaultValues({
          name,
          address,
          whatsapp,
          role,
          status,
          company: company ?? null,
          accountingActionChartOfAccounts: (
            accountingActionChartOfAccounts ?? []
          ).reduce((acc, item) => {
            if (!item.chartOfAccount) return acc;
            if (multiSelectActions.has(item.action)) {
              (acc[item.action] ??= []).push(item.chartOfAccount);
            } else {
              acc[item.action] = item.chartOfAccount;
            }
            return acc;
          }, {}),
          sellerBankAccounts: (sellerBankAccounts ?? []).map(
            (sellerBankAccount) => ({
              ...sellerBankAccount,
              bank: sellerBankAccount.bank,
            })
          ),
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchOutlet();
  }, [outletId]);

  const handleSubmit = async ({
    name,
    address,
    whatsapp,
    role,
    status,
    companyId,
    accountingActionChartOfAccounts,
    sellerBankAccounts,
  }) => {
    try {
      await apiClient.put(`outlets/${outletId}`, {
        name,
        address,
        whatsapp,
        role,
        status,
        companyId,
        accountingActionChartOfAccounts,
        ...(sellerBankAccounts !== undefined && { sellerBankAccounts }),
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal memperbarui outlet"));

      throw error;
    }
  };

  return (
    <OutletFormDialog
      onClose={onClose}
      dialogTitle="Ubah Outlet"
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Simpan
        </Button>
      )}
    />
  );
};

EditOutletFormDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
  outletId: PropTypes.string,
};
